import styled from 'styled-components';

interface IContainer {
  fill?: string;
  color?: string;
  hoverColor?: string;
  borderRadius?: string;
  width?: string;
  height?: string;
  cursor?: string;
}

const container = styled.div<IContainer>`
  color: ${(props) => (props.color ? props.color : '#FFFFFF')};
  cursor: ${(props) => (props.cursor ? props.cursor : 'pointer')};
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : '50%'};
  width: ${(props) => (props.width ? props.width : '2rem')};
  height: ${(props) => (props.height ? props.height : '2rem')};
  fill: ${(props) => (props.color ? props.color : '#FFFFFF')};
  transition-duration: 250ms;

  &hover {
    color: ${(props) => (props.hoverColor ? props.hoverColor : 'inherit')};
    fill: ${(props) => (props.hoverColor ? props.hoverColor : 'inherit')};
    transition-duration: 250ms;
  }
`;

const IconsComponents = {
  Container: container,
};

export default IconsComponents;
